import ThemeContainer from '../../components/theme-container/ThemeContainer';
import { ContentTitle, Title } from '../../components/typography/Heading';
import ThemeContext from '../../context/theme-context';
import { markdownToRawMarkup } from '../../utils/html-utils';
import { getBlockComponentForContent } from '../../utils/cms-utils';
import styles from './content-list.module.less';

export const ContentList = ({ contents }) => (
    <ul className={styles.contentList}>
        {contents.map((content) => (
            <li key={content.sys.id} className={styles.listElement}>
                {getBlockComponentForContent({
                    data: content,
                })}
            </li>
        ))}
    </ul>
);

const ContentListWrapper = ({ contentList }) => {
    const { title, subtitle, content, link, image, category, theme, subtext, bottomContent } = contentList;

    const subtextAsHtml = markdownToRawMarkup(subtext);

    return (
        <ThemeContext.Provider value={{ theme: theme?.fields }}>
            <ThemeContainer className={styles.contentListContainer} id={category?.fields?.slug}>
                {getBlockComponentForContent({ data: image })}
                {title && <ContentTitle className={styles.title}>{title}</ContentTitle>}
                {subtitle && (
                    <Title tag="p" className={styles.subtitle}>
                        {subtitle}
                    </Title>
                )}
                <ContentList contents={content} />
                {subtext && <div className={styles.subtext} dangerouslySetInnerHTML={subtextAsHtml} />}

                {link && (
                    <div className={styles.contentLink}>
                        {getBlockComponentForContent({
                            data: link,
                            props: {
                                className: styles.link,
                            },
                        })}
                    </div>
                )}

                {getBlockComponentForContent({
                    data: bottomContent,
                })}
            </ThemeContainer>
        </ThemeContext.Provider>
    );
};
export default ContentListWrapper;
